jQuery('#latestNewsSlider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: false,
    arrows: true,
    prevArrow: jQuery(".latest-news-prev"),
    nextArrow: jQuery(".latest-news-next"),
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: false,                
                slidesToShow: 1,
            }
        }
    ]
});